module.exports = __webpack_public_path__ + "img/stock6.b44248c3.png";